import styled from '@emotion/styled'

export const FooterContainer = styled.div`
  width: 100%;
  float: left;
  margin-top: 80px;
`
